import { numberMinMax } from './numberMinMax'

/**
 * Validate for currency
 */
export const isValidCurrency = numberMinMax(0, 9999999)
